const textHelpers = require("./text");

function articleSlug(blog) {
  if (!blog) {
    return "";
  }
  if (blog.slug) {
    return blog.slug;
  }
  return textHelpers.stringToSlug(blog.blogTitle);
}

function articlePath(blog) {
  return `/blog/${articleSlug(blog)}/`;
}

function findBySlug(blogs, slug) {
  const matches = (blogs || []).filter((blog) => articleSlug(blog) === slug);
  if (!matches.length) {
    return null;
  }
  return matches.sort((a, b) => Number(b.id) - Number(a.id))[0];
}

function pathSegments(path) {
  return String(path || "")
    .split("/")
    .filter(Boolean)
    .filter((segment) => segment !== "blog");
}

function findFromPath(blogs, path) {
  const segments = pathSegments(path);
  const idSegment = segments.find((segment) => /^\d+$/.test(segment));
  if (idSegment) {
    const byId = (blogs || []).find((blog) => String(blog.id) === idSegment);
    if (byId) {
      return byId;
    }
  }

  for (const segment of segments) {
    if (/^\d+$/.test(segment)) {
      continue;
    }
    const bySlug = findBySlug(blogs, segment);
    if (bySlug) {
      return bySlug;
    }
  }

  return null;
}

module.exports = {
  articleSlug,
  articlePath,
  findBySlug,
  findFromPath,
};
